<div style="position: relative">
  <ion-progress-bar [value]="progress" class="progress-bar" />
  <span class="progress-text" [ngStyle]="{ left: textPosition }">{{ text }}</span>
</div>
